import React, { useState, memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRight, Check, Plus } from 'lucide-react';
export function OfferSection() {
  const BASE_PRICE = 16999;
  const orderBumps = [{
    id: 'lunar',
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/portada_order_bump_1.png?v=1780940203',
    tag: '🌙 Calendario Lunar',
    title: 'Calendario Lunar de Sanación',
    description: 'Aprovecha la energía de cada fase lunar para potenciar tus rituales. El complemento perfecto para tu Planificador de Autocuidado.',
    price: 4490
  }, {
    id: 'programa21',
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/portada_order_bump_2.png?v=1780940203',
    tag: '🔥 Programa Intensivo',
    title: 'Programa de Liberación Emocional de 21 Días',
    description: 'Protocolo intensivo de 3 semanas diseñado para limpiar memorias inconscientes que bloquean tu salud física. Acceso inmediato.',
    price: 8990
  }];
  const [selected, setSelected] = useState<Record<string, boolean>>({});
  const toggleBump = (id: string) => {
    setSelected(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const bumpsTotal = orderBumps.reduce((sum, b) => selected[b.id] ? sum + b.price : sum, 0);
  const total = BASE_PRICE + bumpsTotal;
  const formatARS = (value: number) => `${value.toLocaleString('es-AR')}`;
  const handleCheckout = () => {
    const hasLunar = !!selected['lunar'];
    const hasPrograma = !!selected['programa21'];
    let url = 'https://www.ebookpromax.com/cart/52525845315877:1'; // solo producto principal
    if (hasLunar && hasPrograma) {
      url = 'https://www.ebookpromax.com/cart/52525853901093:1'; // principal + ambos
    } else if (hasLunar) {
      url = 'https://www.ebookpromax.com/cart/52525846397221:1'; // principal + order bump 1
    } else if (hasPrograma) {
      url = 'https://www.ebookpromax.com/cart/52525857964325:1'; // principal + order bump 2
    }
    window.location.href = url;
  };
  const bundleItems = [{
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/portada_ebook_principal.png?v=1780940203',
    title: 'Ebook Maestro: Código de Autocuración',
    subtitle: 'El manual paso a paso',
    value: 15000,
    isMain: true
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Portada_bono_1.png?v=1780940203',
    title: 'BONO 1: Guía de biodecodificación express',
    subtitle: 'El diccionario de emergencia',
    value: 7500
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/portada_bono_2.png?v=1780940203',
    title: 'BONO 2: Planificador de auto cuidado',
    subtitle: 'Tu ruta diaria hacia la salud',
    value: 5000
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/portada_bono_3.png?v=1780940203',
    title: 'BONO 3: 30 Tarjetas de Liberación Emocional',
    subtitle: 'Para imprimir y sanar cada día',
    value: 8000
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/portada_bono_4.png?v=1780940203',
    title: 'BONO 4: 7 Rituales de Emergencia Emocional',
    subtitle: 'Qué hacer ante crisis de estrés',
    value: 4500
  }];
  return <section className="py-24 bg-holistic-cream" id="oferta" data-id="element-96">
      <div className="max-w-5xl mx-auto px-6" data-id="element-97">
        <FadeIn data-id="element-98">
          <div className="text-center mb-12" data-id="element-99">
            <h2 className="text-3xl md:text-4xl font-serif text-holistic-earth mb-4" data-id="element-100">
              Llevate el ecosistema completo de sanación hoy
            </h2>
            <p className="text-lg text-holistic-earth-light" data-id="element-101">
              Todo lo que necesitas para iniciar tu proceso, en un solo lugar.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-102">
          <div className="mb-12 max-w-3xl mx-auto" data-id="element-103">
            <img src="https://cdn.shopify.com/s/files/1/0999/7487/3381/files/bundle_4c41128a-c11c-4558-b218-5031f0482d74.png?v=1780940203" alt="Pack completo Código de Autocuración con todos los bonos" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-104" />
          </div>
        </FadeIn>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-holistic-sand" data-id="element-105">
          <div className="p-8 md:p-12" data-id="element-106">
            <div className="space-y-6" data-id="element-107">
              {bundleItems.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-108">
                  <div className={`flex items-center gap-4 md:gap-6 p-4 rounded-2xl transition-colors ${item.isMain ? 'bg-holistic-sage/10 border border-holistic-sage/20' : 'hover:bg-holistic-sand/30'}`} data-id="element-109">
                    <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl shrink-0 bg-holistic-cream overflow-hidden flex items-center justify-center border border-holistic-sand" data-id="element-110">
                      <img src={item.image} alt={item.title} className="w-full h-full object-contain p-1" data-id="element-111" />
                    </div>
                    <div className="flex-grow" data-id="element-112">
                      <h4 className={`font-bold ${item.isMain ? 'text-lg text-holistic-sage-dark' : 'text-holistic-earth'}`} data-id="element-113">
                        {item.title}
                      </h4>
                      <p className="text-sm text-holistic-earth-light" data-id="element-114">
                        {item.subtitle}
                      </p>
                    </div>
                    <div className="hidden md:block text-right shrink-0" data-id="element-115">
                      <span className="text-sm text-holistic-earth-light line-through" data-id="element-116">
                        Valor: ${item.value.toLocaleString('es-AR')}
                      </span>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <div className="bg-holistic-earth text-white p-8 md:p-12 relative overflow-hidden" data-id="element-117">
            <div className="absolute top-0 right-0 w-64 h-64 bg-holistic-gold/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-118"></div>

            <div className="relative z-10 max-w-2xl mx-auto" data-id="element-119">
              {/* ORDER BUMPS */}
              <FadeIn data-id="element-120">
                <p className="text-sm uppercase tracking-widest font-bold text-holistic-gold mb-1 text-center" data-id="element-121">
                  Potencia tu transformación
                </p>
                <p className="text-holistic-sand/80 text-center mb-6 text-sm" data-id="element-122">
                  Sumá estos complementos exclusivos a tu pedido
                </p>
              </FadeIn>

              <div className="space-y-4 mb-8" data-id="element-123">
                {orderBumps.map(bump => {
                const isActive = !!selected[bump.id];
                return <FadeIn key={bump.id} data-id="element-124">
                      <div className={`rounded-2xl p-4 border-2 transition-colors ${isActive ? 'bg-white border-holistic-gold' : 'bg-white border-holistic-gold bump-glow'}`} data-id="element-125">
                        <div className="flex gap-4 items-start" data-id="element-126">
                          <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg shrink-0 bg-holistic-cream overflow-hidden border border-holistic-sand flex items-center justify-center" data-id="element-127">
                            <img src={bump.image} alt={bump.tag} className="w-full h-full object-contain p-0.5" data-id="element-128" />
                          </div>
                          <div className="flex-grow" data-id="element-129">
                            <span className="inline-block bg-holistic-sand text-holistic-earth-light text-[11px] font-bold px-2.5 py-0.5 rounded-full mb-1.5" data-id="element-130">
                              {bump.tag}
                            </span>
                            <h4 className="font-bold text-holistic-earth leading-snug text-sm md:text-base" data-id="element-131">
                              {bump.title}
                            </h4>
                            <p className="text-xs md:text-sm text-holistic-earth-light mt-1 leading-relaxed" data-id="element-132">
                              {bump.description}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-4 pt-3 border-t border-holistic-sand" data-id="element-133">
                          <span className="font-bold text-holistic-earth" data-id="element-134">
                            + {formatARS(bump.price)}
                          </span>
                          <button type="button" onClick={() => toggleBump(bump.id)} aria-pressed={isActive} className={`inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-holistic-sage ${isActive ? 'bg-holistic-sage text-white' : 'bg-holistic-wine text-white hover:bg-holistic-wine-dark btn-flash'}`} data-id="element-135">
                            {isActive ? <>
                                <Check size={16} data-id="element-136" /> Agregado
                              </> : <>
                                <Plus size={16} data-id="element-137" /> Agregar
                              </>}
                          </button>
                        </div>
                      </div>
                    </FadeIn>;
              })}
              </div>

              {/* PRICE SUMMARY */}
              <div className="text-center" data-id="element-138">
                <p className="text-holistic-sand/80 mb-2 text-lg" data-id="element-139">
                  VALOR TOTAL DEL CONTENIDO:{' '}
                  <span className="line-through" data-id="element-140">$40.000</span>
                </p>

                {bumpsTotal > 0 && <div className="bg-white/10 rounded-xl p-4 mb-4 text-sm space-y-1 max-w-xs mx-auto" data-id="element-141">
                    <div className="flex justify-between text-holistic-sand/90" data-id="element-142">
                      <span data-id="element-143">Código de Autocuración</span>
                      <span data-id="element-144">{formatARS(BASE_PRICE)}</span>
                    </div>
                    {orderBumps.filter(b => selected[b.id]).map(b => <div key={b.id} className="flex justify-between text-holistic-sand/90" data-id="element-145">
                          <span className="truncate pr-2" data-id="element-146">{b.tag}</span>
                          <span className="whitespace-nowrap" data-id="element-147">
                            + {formatARS(b.price)}
                          </span>
                        </div>)}
                  </div>}

                <div className="mb-8" data-id="element-148">
                  <p className="text-sm text-holistic-gold uppercase tracking-widest font-bold mb-2" data-id="element-149">
                    {bumpsTotal > 0 ? 'Total a Pagar' : 'Precio de Lanzamiento'}
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-150">
                    <span className="text-5xl md:text-6xl font-serif font-bold text-holistic-cream" data-id="element-151">
                      {formatARS(total)}
                    </span>
                    <span className="text-xl text-holistic-sand/80" data-id="element-152">ARS</span>
                  </div>
                  <p className="text-holistic-sage-light mt-2 font-medium" data-id="element-153">
                    {bumpsTotal > 0 ? 'Incluye tus complementos seleccionados' : '(Ahorras más de $23.000 hoy)'}
                  </p>
                </div>

                <Button size="lg" variant="primary" onClick={handleCheckout} className="w-full md:w-auto text-lg px-12 group" data-id="element-154">
                  ¡SÍ! QUIERO MI ACCESO INMEDIATO
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-155" />
                </Button>
                <p className="mt-4 text-sm text-holistic-sand/60 flex items-center justify-center gap-2" data-id="element-156">
                  🔒 Pago 100% Seguro y Encriptado
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}